// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__16lBf","row":"Node_row__1KNlK","label":"Node_label__XgTGo","footer":"Node_footer__2oye5"};